<template>
  <div class="tab_simcards">
    <div class="response_table" v-if="simcard_list.length > 0">
      <div class="header_simcards">
        <p class="title">
          {{ translate('simcard_devices.list') }}

          <span>
            ({{ translate('simcard_devices.online') }}:
            {{ count_simcard_online }})
          </span>
        </p>
        <span @click="simcard_show()" class="pointer switch">{{ translate('simcard_devices.not_' + sims_show) }}</span>
      </div>
      <table>
        <thead style="flex: 0">
          <tr>
            <th scope="col" class="status" >
              {{ translate('simcard_devices.status') }}
            </th>
            <th scope="col" class="active">
              {{ translate('simcard_devices.in_device') }}
            </th>
            <th
              scope="col"
              @click="change_filter('slot')"
              class="slot pointer"
              :class="{'selected' : sims_type === 'slot'}"
            >
              {{ translate('simcard_devices.slot') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : sims_sort === 'desc'}"></i>
            </th>
            <th scope="col">
              {{ translate('simcard_devices.mno') }}
            </th>
            <th scope="col">
              {{ translate('simcard_devices.number') }}
            </th>
            <th scope="col">
              {{ translate('simcard_devices.imsi') }}
            </th>
            <th scope="col">
              {{ translate('simcard_devices.iccid') }}
            </th>
            <th scope="col"
              @click="change_filter('ts_sync')"
              class="pointer"
              :class="{'selected' : sims_type === 'ts_sync'}"
            >
              {{ translate('simcard_devices.ts_sync') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : sims_sort === 'desc'}"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
            v-for="(sim,key) in sims_list"
            :key="key"
            :to="get_name_link(sim.imsi)"
            class="link"
            :title="show_traffic_simcard(sim)"
          >
            <tr class="pointer">
              <td class="status" :data-label="translate('simcard_devices.status')">
                <div
                  v-if="sim.sim_state"
                  class="sphere"
                  :style="'background-color:' + sim.sim_state.color"
                  :title="sim.sim_state.signal + ': ' + sim.sim_state.sig_lvl"
                />
              </td>
              <td class="active" :data-label="translate('simcard_devices.in_device')">
                <span v-if="sim.active" class="mdi mdi-check-circle-outline fz16"></span>
                <span v-else class="mdi mdi-checkbox-blank-circle-outline fz16"></span>
              </td>
              <td class="slot" :data-label="translate('simcard_devices.slot')">
                {{ sim.slot }}
              </td>
              <td :data-label="translate('simcard_devices.mno')">
                {{ sim.mno }}
              </td>
              <td :data-label="translate('simcard_devices.number')">
                {{ sim.msisdn }}
              </td>
              <td data-label="imsi">
                {{ sim.imsi }}
              </td>
              <td data-label="iccid">
                {{ sim.iccid }}
              </td>
              <td data-label="ts">
                {{ get_date(sim.ts_sync) }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'simcard_list',
  props: ['title', 'simcard_list'],
  data () {
    return {
      // sims_list: [],
      sims_sort: 'desc',
      sims_type: 'slot',
      sims_show: 'active',
    }
  },
  computed:{
    sims_list(){
      let list = []
      if (this.sims_show === 'active') {
        for (let simcard of this.simcard_list) {
          if (simcard.active === 1) {
            list.push(simcard)
          }
        }
      }else{
        list = this.simcard_list
      }

      list.sort(this.compareNumbers)

      return list
    },
    count_simcard_online () {
      let count_online = 0
      if (this.simcard_list){
        for (let simcard of this.simcard_list) {
          if (simcard.active === 1){
            count_online += 1
          }
        }
      }
      return count_online
    }
  },
  methods: {
    show_traffic_simcard(simcard){
      if (simcard.simcard_profile && simcard.simcard_profile.traffic){
        let traffic = simcard.simcard_profile.traffic
        let value = this.balance_trafic(traffic)
        return value + ' ' + this.translate("simcard_devices.out_of") + ' ' + (traffic.balance_limit > 1024*5 ? Math.round(traffic.balance_limit/1024)+' GB' : traffic.balance_limit+' MB')
      }
    },
    balance_trafic(traffic){
      let trafic_GB = +traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return Math.round(trafic_GB)
      }
      return traffic.balance_value + ' MB'
    },
    change_filter(type){
      if (this.sims_type === type) {
        this.sims_sort = this.sims_sort === 'asc' ? 'desc' : 'asc'
      }else{
        this.sims_type = type
      }
    },
    compareNumbers(a, b) {
      if (typeof(a[this.sims_type]) == 'string') {
        if (this.sims_sort === 'asc') {
          return a[this.sims_type] < b[this.sims_type] ? 1 : -1;
        }else{
          return a[this.sims_type] > b[this.sims_type] ? 1 : -1;
        }
      }else if (typeof(a[this.sims_type]) == 'number') {
        if (this.sims_sort === 'asc') {
          return a[this.sims_type] - b[this.sims_type]
        }else{
          return b[this.sims_type] - a[this.sims_type]
        }
      }
    },
    simcard_show(){
      this.sims_show = this.sims_show === 'all' ? 'active' : 'all'
    },
    get_simcard_status (sim) {
      return sim.status ? 1 : 0
    },
    simcard_status_text(simcard_profile){
      if (!simcard_profile) return this.translate('simcard_profile.status_info.undefined')

      switch (simcard_profile.status) {
        case -1: return this.translate('simcard_profile.status_info.undefined')
        case 1: return this.translate('simcard_profile.status_info.active')
        case 2: return this.translate('simcard_profile.status_info.blocked')
        case 3: return this.translate('simcard_profile.status_info.prepare')
        case 4: return this.translate('simcard_profile.status_info.stop')
      }
    },
    simcard_status_color(simcard_profile){
      if(!simcard_profile)
        return 'gray'

      switch (simcard_profile.status) {
        case -1: return 'gray'
        case 1: return 'green'
        case 2: return 'yellow'
        case 3: return 'blue'
        case 4: return 'red'
      }
    },
    get_name_link (imsi) {
      if (this.$store.getters.getPermissions.permissionGod === true) {
        return {path: '/simcard_devices/' + imsi}
      }
      return {}
    },
  }
}
</script>
<style lang='scss' scoped>
  .tabs-component-panel .tab_simcards{
    .header_simcards{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .title{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        margin-bottom: 0;
        span{
          font-weight: normal;
          font-size: 12px;
          color: #9A9A9A;
        }
      }
      .switch{
        font-size: 12px;
        line-height: 120%;
      }
    }
    .response_table{
      padding: 0;
      table{
        .status{
          width: 40px;
          vertical-align: middle;
        }
        .active{
          width: 70px;
          .fz16{
            font-size: 16px;
          }
        }
        .slot{
          width: 50px;
        }
        tbody{
          .link{
            color: black;
          }
        }
      }
      table tr {
        background-color: white;
        &:hover{
          background-color: #f1f1f1;
        }
        th{
          .mdi-arrow-down{
            width: 0;
            opacity: 0;
            display: inline-block;
            transform: rotate(0);
            transition: 0.2s;
            &.reverse::before{
              transform: rotate(180deg);
            }
          }
          &.selected{
            .mdi-arrow-down{
              opacity: 1;
              width: 10px;
            }
          }
        }
      }
      &:first-child{
        margin-bottom: 10px;
      }

    }
  }
  .pointer{
    cursor: pointer;
  }
 </style>
